define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/window",
	"dojo/data/util/sorter",
	"csi/core/ExtendedPath",
	"csi/reflection"
], function(array, declare, window, sorter, ExtendedPath, reflection) {

	return declare(null,
		{
			// Object[] - A JS object that array that defines out what attribute names to sort on and whether it should be descenting or asending.
			//		The objects should be formatted as follows:
			//		{
			//			attribute: "attributeName-string" || attribute,
			//			descending: true|false;   // Default is false.
			//		}
			sortSpec: [{attribute: "isRelationship"}, {attribute: "text"}]
		}
	);
});